// extracted by mini-css-extract-plugin
export var blue = "_2f-f";
export var brand = "_2f-b";
export var darkGrey = "_2f-e";
export var disabled = "_2f-4";
export var disabledSubtle = "_2f-5";
export var error = "_2f-6";
export var green = "_2f-g";
export var grey = "_2f-d";
export var icon = "_2f-0";
export var inherit = "_2f-a";
export var lightGrey = "_2f-c";
export var orange = "_2f-i";
export var pink = "_2f-k";
export var primary = "_2f-1";
export var purple = "_2f-l";
export var red = "_2f-j";
export var secondary = "_2f-2";
export var success = "_2f-9";
export var tertiary = "_2f-3";
export var warning = "_2f-7";
export var warningSecondary = "_2f-8";
export var white = "_2f-m";
export var yellow = "_2f-h";